import React from 'react';
import {NavLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import './TabLinks.scss';
import {slugify} from '../../utils/dataQa';

const TabLink = ({linkTo, tabCount, children, dataQa}) => {
    return (
        <NavLink
            exact
            className="ace-tab-link__title"
            activeClassName="ace-tab-link__title--active"
            to={linkTo}
            data-qa={dataQa || `tab-link-${slugify(linkTo)}`}
        >
            {children}
            {!!tabCount && (
                <span className="ace-tab-link__result-counter">
                    {tabCount}
                </span>
            )}
        </NavLink>
    );
};

TabLink.propTypes = {
    linkTo: PropTypes.string.isRequired,
    tabCount: PropTypes.number,
    dataQa: PropTypes.string,
};

TabLink.defaultProps = {
    tabCount: 0,
    dataQa: '',
};

export default TabLink;
